"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import isLoggedIn from "@/app/redirect";
import { checkAndRedirectToLanding } from "@/app/(pages)/(prelogin)/(registerlogin)/login/login-utils";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { renderLoginComponentV2 } from "./loginComponents/login-utils";

const projectCode = process.env.NEXT_PUBLIC_PROJECT_CODE;
const projectCodeAsset = process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET;

function LoginV2() {
  const { config } = useClientConfigProvider();
  const router = useRouter();

  const [LoginComponent, setLoginComponent] =
    useState<React.ComponentType | null>(null);

  useEffect(() => {
    checkAndRedirectToLanding(config, router);

    const loadComponent = async () => {
      switch (projectCode) {
        case "SCB_V1":
          // const mod = await import(`./client-wise/${projectCodeAsset}/index`);
          const mod = await import(`./client-wise/scb/index`);
          setLoginComponent(() => mod.default);
          break;

        default:
          setLoginComponent(() => () => renderLoginComponentV2(config));
          break;
      }
    };

    loadComponent();
  }, [config, router]);

  if (!LoginComponent) return null; // optionally return a loader

  return <LoginComponent />;
}

export default isLoggedIn(LoginV2);
